module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-pickwick.fce2cba0.svg";